import CurrentDriverReportTable from "./CurrentDriverReportTable";

export default function CurrentDriverReport() {
  return <CurrentDriverReportTable />;
}